import SectionHeading from "@/components/base/SectionHeading";

const rhythm = [
  {
    time: "07:00 - 09:00",
    title: "晨间汇总",
    desc: "整理夜间发生的动态，补齐昨天遗留话题的时间线，输出当日精选。",
    icon: "ri-sun-line",
  },
  {
    time: "12:00 - 14:00",
    title: "午间跟进",
    desc: "跟进上午的新进展，更新热榜排序，把讨论度上升的话题提到首页。",
    icon: "ri-sun-cloudy-line",
  },
  {
    time: "19:00 - 22:00",
    title: "晚间高峰",
    desc: "热点最集中的时段，实时滚动更新，重要反转会单独标注提醒。",
    icon: "ri-moon-clear-line",
  },
  {
    time: "22:00 - 次日",
    title: "值班守候",
    desc: "值班编辑跟进突发话题，确保第二天早上你能看到完整的经过。",
    icon: "ri-moon-line",
  },
];

export default function RhythmSection() {
  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-50">
      <SectionHeading
        eyebrow="更新节奏"
        title="一天的瓜，是这样跟下来的"
        desc="从清晨到深夜，总有人在盯着进展。"
      />
      <ol className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
        {rhythm.map((item, index) => (
          <li
            key={item.time}
            className="relative rounded-lg bg-background-100 border border-background-200 p-5 md:p-6"
          >
            <span className="w-11 h-11 rounded-md bg-primary-500 text-background-50 flex items-center justify-center mb-4">
              <i className={`${item.icon} text-xl`} aria-hidden="true"></i>
            </span>
            <span className="block text-xs text-primary-600 bg-primary-50 border border-primary-100 rounded-full px-2.5 py-1 w-fit">
              {item.time}
            </span>
            <h3 className="mt-3 text-base font-bold text-foreground-950">
              {item.title}
            </h3>
            <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
              {item.desc}
            </p>
            {index < rhythm.length - 1 && (
              <i
                className="hidden lg:block absolute top-1/2 -right-4 ri-arrow-right-line text-background-400"
                aria-hidden="true"
              ></i>
            )}
          </li>
        ))}
      </ol>
    </section>
  );
}